import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarrierSalesProfileList extends Layout {
    layoutheaderSearchCarrierSalesProfiles: LayoutHeader;
    sourceCarrierSalesProfile: DataSource;
    tableProfiles: Table;
}
